import React from 'react'
import { NavLink } from 'react-router-dom'
import { string, node, func } from 'prop-types'

export const componentsTags = {
  link: ({
    children, to, className, onClick, ariaLabel,
  }) => (
    <NavLink
      aria-label={ariaLabel}
      to={to}
      onClick={onClick}
      className={className}
      data-auto-id='linkPromo'
    >
      {children}
    </NavLink>
  ),
  span: ({ children, ariaLabel, ...rest }) => <span {...rest}>{children}</span>,
}

componentsTags.link.propTypes = {
  to: string.isRequired,
  className: string,
  children: node,
  onClick: func.isRequired,
  ariaLabel: string.isRequired,
}

componentsTags.link.defaultProps = {
  className: '',
  children: null,
}

componentsTags.span.propTypes = {
  children: node,
  ariaLabel: string,
}

componentsTags.span.defaultProps = {
  children: null,
  ariaLabel: '',
}



// WEBPACK FOOTER //
// ./shared/interim/product/promo/componentsTags.js